import { Component, DestroyRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SecurityService } from '../../../services/security-service';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs';
import { Constante } from '../../../constante';
import { AuthUtility } from '../../../core/utility/auth-utility';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UsuarioAS } from '../../../core/models/usuarioas';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgClass } from '@angular/common';
import { AppService } from '../../../core/services/app-service';

@Component({
  selector: 'app-authentication-component',
  imports: [MatProgressSpinnerModule, NgClass],
  templateUrl: './authentication-component.html',
  styleUrl: './authentication-component.scss',
})
export class AuthenticationComponent {
  mensajeApp: string = 'Cargando la aplicación'
  lAcceso: boolean = false
  lPerfiles: boolean = false
  listaPerfiles: any[] = [];
  _const = Constante

  constructor(
    private router: Router,
    private activeRoute: ActivatedRoute,
    private securityService: SecurityService,
    private destroyRef: DestroyRef,
    private toastr: ToastrService,
    private appService: AppService
  ) {
    this.activeRoute.params
      .pipe(take(1))
      .subscribe((routeParams: any) => {
        ////console.log("routeParams", routeParams);

        AuthUtility.setTokenIdentity(routeParams.token);
        AuthUtility.initSessionData(routeParams.token);
        this.validarUsuario()
        // console.log(routeParams.token)
      });
  }
  getFirstTwoWords(str: string) {
    const words = str.split(" ");

    if (words.length >= 2) {
      let _nameUser = words[0].replace(/\s/g, "");
      let _apeUser = words[1].replace(/\s/g, "");

      /*_nameUser = _nameUser.toLowerCase();
      _apeUser = _apeUser.toLowerCase();


      _nameUser = _nameUser.replace(/^./, function (match) {
          return match.toUpperCase();
      });

      _apeUser = _apeUser.replace(/^./, function (match) {
          return match.toUpperCase();
      })*/

      return _nameUser + ' ' + _apeUser;
    } else {
      return str;
    }
  }
  validarUsuario() {
    this.securityService.validarIngreso()
      .pipe(take(1), takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (response: any) => {
          if (response.success == this._const.REQUEST_STATUS_OK) {
            this.lAcceso = true
            let _user = new UsuarioAS();
            _user.idUsuario = response.data.idUsuario;
            _user.cNombreUsuario = response.data.cNombreUsuario;
            _user.cNombreCompleto = response.data.cNombreCompleto;
            _user.cNombreCorto = this.getFirstTwoWords(_user.cNombreCompleto);

            AuthUtility.setValueUserAS(_user);
            this.router.navigate([this._const.URL_DASHBOARD]);

          }
          else if (response.success == this._const.REQUEST_STATUS_ERROR) {
            this.toastr.error(response.errors[0].message, this._const.MESSAGE_TITLE_ERROR);
            this.appService.goToLogin();
          }

        },
        error: (response: any) => {
          console.error("No se puedo obtener resultados del servidor", response);
        }
      });
  }
}
